import { CurrencyPipe } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    LOCALE_ID,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {
    UntypedFormControl,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import $ from 'jquery';
import clone from 'just-clone';
import moment from 'moment';
import { combineLatest, ReplaySubject } from 'rxjs';
import { filter, startWith, take, takeWhile, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as fromDataServices from '../../data-services';
import { ProjectBudget } from '../../data-services/project-budget/project-budget.model';
import { IUserGroup } from '../../lookups';
import {
    flatDeep,
    getDynamicColumns,
    IColumn,
    ResponseStatus
} from '../../shared';
import {
    Calendar,
    MenuItem,
    SelectItem,
    Table
} from '../../shared/efaact-primeng.module';
import { DisplayErrors } from '../../shared/errors-sidenav';
import { UnsavedChangesService } from '../../shared/modal-dialog';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromUser from '../../user-info';
import { UserRoleEnum } from '../../user-info';
import { IUserRole } from '../../user-role/IUserRole';
import { ProjectBudgetService } from '../project-budget.service';
import * as XLSX from 'xlsx';
@Component({
    selector: 'ef-project-budget',
    templateUrl: './project-budget.component.html',
    styleUrls: ['./project-budget.component.scss'],
    standalone: false
})
export class ProjectBudgetComponent
    extends DisplayErrors<ProjectBudget>
    implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
    // cols$: Observable<IColumn[]>;
    // colGroups$: Observable<IColumn[]>;
    moment: any;
    filterItems = ['Status', 'AutoCalculateAmount', 'Row_Version', 'updates'];
    cols: IColumn[] = [];
    public get tableCols(): { field: any; header: string }[] {
        return this.cols
            .filter(c => c.showColumn)
            .map(c => ({
                field: this.onGetField(c.field, c.group),
                header: `${c.group} - ${c.header}`,
                exportable: c.exportable
                // class: c.class,
                // group: c.group,
                // style: c.style
            }));
    }
    // tableCols: any[] = [];
    public dropdownItemHeight = environment.dropdownItemHeight;
    frozenCols: any[] = [
        { field: 'TaskLongName', header: 'Task' },
        { field: 'CostType', header: 'Cost Type' },
        { field: 'ServiceItem', header: 'Service Item' },
        { field: 'PersonName', header: 'Person' },
        { field: 'PayrollItem', header: 'PayrollItem' },
        { field: 'CostCenter', header: 'CostCenter' }
    ];
    colGroups: IColumn[] = [];
    active = true;
    baseWidth = 120;
    tableWidth = `${this.baseWidth}em`;
    BudgetCycleSubject = new ReplaySubject<string>(1);
    FYEndDateSubject = new ReplaySubject<Date>(1);
    FYStartDateSubject = new ReplaySubject<Date>(1);
    showPerson = true;
    showEmptyBudgets = true;
    showDisbursment = false;
    showPeriodTotal = false;
    showAmounts = true;
    showActuals = false;
    showUploadDialog = false;
    showUploadError = false;
    excelFileAsJsonStr: string | null | undefined;
    excelFileAsJson: any;
    budgetUpload = false;
    budgetUploadDate: any;
    @Output() uploadJSON = new ReplaySubject(1);
    @ViewChild('fileUpload') uploadInput: ElementRef;
    @Input() tableScrollHeight;
    IsColumnFrozen = false;
    showOptions = false;
    showUpdateBudgetDialog = false;
    updateBudgetForm: UntypedFormGroup;
    selectedBudgetForUpdate: ProjectBudget | null = null;
    tasks: SelectItem[] = [];
    costTypes: SelectItem[] = [];
    costCenters: SelectItem[] = [];

    get numCols(): number {
        let ret = 0;
        if (this.showDisbursment) {
            ret += 3;
        }
        if (this.showPeriodTotal) {
            ret += 1;
        }
        if (this.showAmounts && this.showPeriodTotal) {
            ret += 1;
        }
        ret += this.cols.length;
        if (this.cols.length == 0) {
            ret = 0;
        }
        return ret;
    }
    get frozenHeaderBudgetColspan(): number {
        const colspan = 3;
        return colspan;
    }
    get frozenHeaderBudget2Colspan(): number {
        let colspan = 1;
        if (this.showPerson) {
            colspan += 2;
        }
        // if (this.CostCenters && this.CostCenters.length > 1) {
        //     colspan += 1;
        // }
        return colspan;
    }
    get disbursementHeaderGroupWidth(): number {
        const width = 128; //2 small widths
        return width * 2 + 44 - 1; //add a delete cell width
    }
    get totalsHeaderGroupWidth(): number {
        const width = 64; //2 small widths
        return width * 2 - 1; //add a delete cell width
    }
    get budgetHeaderGroupWidth(): number {
        // var colwidth = 159 + 1 / 6;
        const colwidth = 160;
        const px = colwidth * 3;
        return px - 1;
    }
    get budget2HeaderGroupWidth(): number {
        // var colwidth = 159 + 1 / 6;
        const colwidth = 160;
        let px = colwidth * 0;
        if (this.showPerson) {
            px += colwidth * 2;
        }
        // if (this.CostCenters && this.CostCenters.length > 1) {
        px += colwidth;
        // }
        return px;
    }
    get numFrozenCols(): number {
        return 2; // Only select and delete columns are frozen
    }
    get hasRowSelected(): boolean {
        return this.dataTable?.selection && this.dataTable.selection.length === 1;
    }
    get hasMultipleRowsSelected(): boolean {
        return this.dataTable?.selection && this.dataTable.selection.length > 1;
    }
    get hasAnyRowsSelected(): boolean {
        return this.dataTable?.selection && this.dataTable.selection.length > 0;
    }
    isRowSelected(item: ProjectBudget): boolean {
        return (
            this.hasRowSelected &&
            this.dataTable?.selection &&
            this.dataTable.selection.length === 1 &&
            this.dataTable.selection[0]?.id === item?.id
        );
    }
    get periodOptions(): SelectItem[] {
        if (!this.selectedBudgetForUpdate) {
            return [];
        }
        return this.colGroups
            .filter(cg => {
                const periodData = this.selectedBudgetForUpdate?.[cg.field];
                return (
                    periodData &&
                    typeof periodData === 'object' &&
                    periodData.TxnID
                );
            })
            .map(cg => {
                const periodData = this.selectedBudgetForUpdate![cg.field];
                return {
                    label: cg.header,
                    value: periodData.TxnID
                };
            });
    }
    get dynamicHeaderWidth() {
        let numCols = 2;
        if (this.showActuals) {
            numCols += 4;
        }
        const colwidth = 96 * numCols;
        const fudge = numCols - 1;
        return colwidth; // - (fudge < 1 ? 1 : fudge);
    }
    private _FYEndDate: Date;
    @Input() public set FYEndDate(value: Date) {
        this.log.verbose({
            type: 'ProjectBudgetComponent:FYEndDate:set',
            FYEndDate: value
        });
        this._FYEndDate = value;
        this.FYEndDateSubject.next(value);
    }
    public get FYEndDate(): Date {
        return this._FYEndDate;
    }
    private _FYStartDate: Date;
    @Input() public set FYStartDate(value: Date) {
        this.log.verbose({
            type: 'ProjectBudgetComponent:_FYStartDate:set',
            _FYStartDate: value
        });
        this._FYStartDate = value;
        this.FYStartDateSubject.next(value);
    }
    public get FYStartDate(): Date {
        return this._FYStartDate;
    }
    @Input() contract: fromDataServices.Contract.Summary.ContractSummary;
    @Input() roles: IUserRole[];
    @Input() public set download(value) {
        this.log.verbose({
            type: 'ProjectBudgetComponent:download:set',
            value,
            cols: this.cols,
            tableCols: this.tableCols
        });
        if (value) {
            this.dataTable.columns = this.tableCols;
            this.dataTable.exportCSV.bind(this.dataTable)();
            this.dataTable.columns = this.cols;
        }
    }
    private _budgetCycle: string;
    @Input() public set BudgetCycle(value: string) {
        this._budgetCycle = value;
        this.BudgetCycleSubject.next(value);
    }
    public get BudgetCycle(): string {
        return this._budgetCycle;
    }

    // DirectReportSubject = new ReplaySubject<SelectItem[]>(1);
    // private _dr: SelectItem[];
    // @Input() public set directReports(value: SelectItem[]) {
    //     if (value && value.length > 0) {
    //         value.push({label: '_Unassigned Employee', value: 'SYS000000000000000000000000000000000'});
    //         this._dr = value;
    //         this.DirectReportSubject.next(value);
    //     }
    // }
    // public get directReports(): SelectItem[] {
    //     return this._dr;
    // }
    @Input() disabled: boolean;
    @Input() userInfo: fromUser.IUserInfo;
    @Input() allowCost: boolean;
    @Input() loading: boolean;
    @Input() CostCenters: IUserGroup[];
    @Input() AutoCalculateAmount: boolean;
    @Input() directReports: SelectItem[];
    @Input() serviceItems: SelectItem[];
    @Input() payrollItems: SelectItem[];
    filteredItems: ProjectBudget[];
    @Output() SaveMetadata =
        new ReplaySubject<fromDataServices.ProjectBudget.ProjectBudget>(1);
    @Output() Save =
        new ReplaySubject<fromDataServices.ProjectBudget.ProjectBudget>(1);
    @Output() Edit =
        new ReplaySubject<fromDataServices.ProjectBudget.ProjectBudget>(1);
    @Output() Cancel =
        new ReplaySubject<fromDataServices.ProjectBudget.ProjectBudget>(1);
    @Output() Delete =
        new ReplaySubject<fromDataServices.ProjectBudget.ProjectBudget>(1);
    @Output()
    Select = new ReplaySubject<fromDataServices.ProjectBudget.ProjectBudget>(1);
    @Output() Add = new ReplaySubject(1);
    @Output() Jumpstart = new ReplaySubject(1);
    @Output() FiscalYearChange = new EventEmitter<Date[]>();
    @Output() Download = new ReplaySubject<string>(1);
    @Output() SelectPerson = new ReplaySubject<string>(1);
    @Output() UpdateBudget = new ReplaySubject<any>(1);
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('budgetDateFilter', { static: true }) budgetDateFilter: Calendar;
    public editing?: fromDataServices.ProjectBudget.ProjectBudget;
    public maxBudgetDate: Date = new Date();
    selected: fromDataServices.ProjectBudget.ProjectBudget[] = [];
    cloned: { [i: number]: fromDataServices.ProjectBudget.ProjectBudget } = {};
    budgetForm: UntypedFormGroup;
    theight = '45vh';
    downloadOptions: MenuItem[] = [
        {
            label: 'Budget Contract Summary',
            icon: 'pi pi-download',
            command: () => this.Download.next('contract')
        },
        {
            label: 'Budget Task Detail',
            icon: 'pi pi-download',
            command: () => this.Download.next('budget')
        }
    ];
    constructor(
        private log: LoggingService,
        public confirmservice: UnsavedChangesService,
        private cdRef: ChangeDetectorRef,
        @Inject(LOCALE_ID) private locale: string,
        private service: ProjectBudgetService
    ) {
        super();
        this.moment = moment;
        this.budgetForm = new UntypedFormGroup({
            StartDate: new UntypedFormControl(null, Validators.required),
            EndDate: new UntypedFormControl(null, Validators.required),
            AutoCalculateAmount: new UntypedFormControl(null)
        });
        this.updateBudgetForm = new UntypedFormGroup({
            TaskListID: new UntypedFormControl(null),
            CostType: new UntypedFormControl(null),
            SIListID: new UntypedFormControl(null),
            PersonListID: new UntypedFormControl(null),
            PIListID: new UntypedFormControl(null),
            CostCenterID: new UntypedFormControl(null),
            Periods: new UntypedFormControl([], Validators.required),
            Hours: new UntypedFormControl(null, [
                Validators.required,
                Validators.min(0)
            ]),
            Amount: new UntypedFormControl(null, [
                Validators.required,
                Validators.min(0)
            ]),
            Disburse: new UntypedFormControl(false)
        });
    }
    onResize($event) {
        // $('document').on('resize', () => {
        this.log.verbose({ type: 'ProjectBudgetComponent:resize', $event });
        const tbHeight = $('#tbBudgetDetail').height() ?? 0;
        const containerHeight = $('#divProjectDetailContainer').height() ?? 0;
        const tableHeight = containerHeight - tbHeight;
        this.log.verbose({
            type: 'ProjectBudgetComponent:resize',
            tbHeight,
            containerHeight,
            tableHeight
        });
        $('#dataTable').height(tableHeight - 5);
        // });
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes.items) {
            if (changes.items.previousValue) {
                if (this.editing) {
                    this.onRowEditCancel(this.editing);
                }
            }
            if (changes.items.currentValue) {
                const value = changes.items.currentValue;
                this.log.verbose({
                    type: 'ProjectBudgetComponent:items:set',
                    colGroups: this.colGroups,
                    items: value
                });
                this.colGroups = [];
                this.cols = [];
                this.filteredItems = [];
                this.tableWidth = `${this.baseWidth}em`;
                if (Array.isArray(value) && value.length > 0) {
                    this.mapColumns(value[0]);
                    this.showEmptyBudgetsChange();
                }
                this.onResize(null);
            }
        }
        if (changes.allowCost && changes.allowCost.currentValue) {
            this.log.verbose({
                type: 'ProjectBudgetComponent:allowCost:set',
                colGroups: this.colGroups,
                allowCost: changes.allowCost.currentValue
            });
            this.showAmounts =
                this.isAdmin(this.roles) ||
                (this.allowCost && this.isTaskManager(this.roles));
            this.cdRef.markForCheck();
        }
        if (changes.AutoCalculateAmount) {
            this.log.verbose({
                type: 'ProjectBudgetComponent:AutoCalculateAmount:set',
                AutoCalculateAmount: changes.AutoCalculateAmount.currentValue
            });
            this.budgetForm
                ?.get('AutoCalculateAmount')
                ?.setValue(changes.AutoCalculateAmount.currentValue);
            setTimeout(() => {
                this.onAutoCalcChange({
                    checked: changes.AutoCalculateAmount.currentValue
                });
            }, 0);
        }
    }
    ngOnInit(): void {
        this.setupSubscriptions();
        this.showAmounts =
            this.isAdmin(this.roles) ||
            (this.allowCost && this.isTaskManager(this.roles));
    }
    ngAfterViewInit(): void {}
    ngOnDestroy(): void {
        this.active = false;
    }
    openUploadDialog() {
        this.showUploadDialog = true;
    }

    uploadExcelFile($event) {
        this.showUploadError = false;
        this.fileToString($event.target.files[0]);
    }

    fileToString(file) {
        const fileNameSpan = document.getElementById('file-selected');
        if (fileNameSpan) {
            fileNameSpan.textContent = file.name;
        }

        const reader = new FileReader();
        reader.onload = event => {
            const binaryData = event.target?.result;
            this.excelToJSON(binaryData);
        };
        reader.readAsBinaryString(file);
    }

    excelToJSON(binaryData) {
        const workbook = XLSX.read(binaryData, { type: 'binary' });

        const jsonData = workbook.SheetNames.reduce((initial, name) => {
            const sheet = workbook.Sheets[name];
            initial = XLSX.utils.sheet_to_json(sheet);
            return initial;
        }, {});

        this.excelFileAsJson = jsonData;
        //this.excelFileAsJsonStr = JSON.stringify(jsonData);
        //console.log(this.excelFileAsJsonStr);
    }

    sendJSON() {
        if (this.excelFileAsJson != null) {
            this.budgetUpload = true;
            this.excelFileAsJson = this.excelFileAsJson.map(x => ({
                ...x,
                PeriodEndDate: moment(
                    this.dateToISODateString(x.PeriodEndDate)
                ).format('MM/DD/YY')
            }));
            this.budgetUploadDate = this.excelFileAsJson[0].PeriodEndDate;
            this.excelFileAsJsonStr = JSON.stringify(this.excelFileAsJson);
            this.uploadJSON.next(this.excelFileAsJsonStr);
            this.reset();
        } else {
            this.showUploadError = true;
            this.budgetUpload = false;
        }
    }

    cancelUpload() {
        this.showUploadError = false;
        this.reset();
    }
    reset() {
        this.showUploadError = false;
        this.showUploadDialog = false;
        this.excelFileAsJsonStr = null;
        this.uploadInput.nativeElement.value = '';
        const fileNameSpan = document.getElementById('file-selected');
        if (fileNameSpan) {
            fileNameSpan.textContent = '';
        }
    }
    dateToISODateString(excelDate) {
        return this.excelDateConversion(excelDate).toISOString().split('T')[0];
    }
    excelDateConversion(excelDate) {
        return new Date(Date.UTC(0, 0, excelDate - 1));
    }
    getColSpan(item, column) {
        // let keys = Object.keys(item[column]);
        const cols = Object.keys(item[column]);
        let span = cols.length - 1;
        if (!this.showAmounts) {
            span =
                span -
                cols.filter(x => x.toLocaleLowerCase().includes('amount'))
                    .length;
        }
        if (!this.showActuals) {
            span =
                span -
                cols.filter(x => x.toLocaleLowerCase().includes('actual'))
                    .length;
            span =
                span -
                cols.filter(x => x.toLocaleLowerCase().includes('variance'))
                    .length;
        }
        span =
            span -
            cols.filter(x => x.toLocaleLowerCase().includes('forecast')).length;
        return span;
        // return this.showAmounts
        //     ? Object.keys(item[column]).length - 1
        //     : Object.keys(item[column]).filter(x =>
        //           x.toLocaleLowerCase().includes('amount')
        //       ).length;
    }
    mapColumns(item: ProjectBudget) {
        // getBudgetDynamicColumns returns the dynamic column groups, i.e 01January or Week Ending XXX
        // each of these groups has data nested under it, i.e. hours, amounts, variance, etc
        const dynCols = getDynamicColumns(item, this.filterItems);
        // const colspan = this.showAmounts
        //     ? Object.keys(item[dynCols[0]]).length - 1
        //     : Object.keys(item[dynCols[0]]).length - 2;
        const colspan = this.getColSpan(item, dynCols[0]);

        this.colGroups = dynCols.map(x => ({
            field: x,
            header: x,
            colspan: this.getColSpan(item, x), // apparently width 0 TD's don't count, also remove TxnID
            showColumn: true,
            group: null as any
        }));

        function getColumnStyle(
            field: string,
            contract: fromDataServices.Contract.Summary.ContractSummary
        ): string {
            let result = '';
            // if (field === 'TxnID') {
            //     result = 'width:0;display:none;';
            // }
            // if (field.includes('Hours')) {
            //     result = 'width: 5em;';
            // }
            // if (field.includes('Forecast') && !contract.BudgetLock) {
            //     result = 'width:0;display:none';
            // }
            result += 'white-space: normal;';
            return result;
        }
        function getColumnClass(
            field: string,
            contract: fromDataServices.Contract.Summary.ContractSummary
        ): string {
            let result = '';
            if (field.includes('Amount')) {
                result += ' currency';
            }
            if (field.includes('Hours')) {
                result += ' hours';
            }
            if (field.includes('Actual') || field.includes('Variance')) {
                result += ' disabled';
            }
            if (field.includes('Forecast') && !contract.BudgetLock) {
                result += ' disabled';
            }
            if (contract.BudgetLock && !field.includes('Forecast')) {
                result += ' disabled';
            }
            return result;
        }
        function getColumnHidden(
            field: string,
            contract: fromDataServices.Contract.Summary.ContractSummary
        ): boolean {
            let result = false;
            if (field === 'TxnID') {
                result = true;
            }
            if (field.includes('Forecast') && !contract.BudgetLock) {
                result = true;
            }
            return result;
        }

        // this takes the column groups and sets up the columns under each group with an IColumn structure
        this.cols = flatDeep(
            this.colGroups.map(cg =>
                Object.keys(item[cg.field])
                    .map(x => ({
                        group: cg.field,
                        field: x,
                        header: x,
                        exportable: x === 'TxnID' ? false : true,
                        style: getColumnStyle(x, this.contract),
                        hidden: getColumnHidden(x, this.contract),
                        // style: 'width: 7em',
                        class: getColumnClass(x, this.contract),
                        // class: 'currency',
                        showColumn: this.getShowColumn(x)
                    }))
                    .filter(x => x.showColumn)
            )
        );
        this.log.verbose({
            type: 'ProjectBudgetComponent:mapColumns',
            cols: this.cols,
            colgroups: this.colGroups,
            showAmounts: this.showAmounts,
            item
        });
        this.tableWidth = `${
            this.baseWidth + colspan * 8 * this.colGroups.length
        }em`;
        // this.ItemsSubject.next(this._items);

        // Set column frozen after columns are mapped and table is ready
        this.cdRef.detectChanges();
        this.setColumnFrozenWhenReady();
    }
    getShowColumn(column: string) {
        let showColumn = true;
        if (column.toLocaleLowerCase().includes('actual')) {
            showColumn = showColumn && this.showActuals;
        }
        if (column.toLocaleLowerCase().includes('variance')) {
            showColumn = showColumn && this.showActuals;
        }
        // INFO: this has to come after the showActuals check b/c there are colums that have both
        if (column.toLocaleLowerCase().includes('amount')) {
            showColumn = showColumn && this.showAmounts;
        }
        return showColumn;
    }
    setupSubscriptions() {
        combineLatest([this.FYStartDateSubject, this.FYEndDateSubject])
            .pipe(
                takeWhile(() => this.active),
                tap(x =>
                    this.log.verbose({
                        type: 'ProjectBudgetContractComponent:FY:tap',
                        x
                    })
                ),
                filter(
                    ([fyStartDate, fyEndDate]) => !!fyStartDate && !!fyEndDate
                )
            )
            .subscribe(([fyStartDate, fyEndDate]) => {
                const controls = this.budgetForm.controls;
                // const initialDate = fydates.find(
                //     x => x.value === moment(fy).format('MM/DD/YYYY')
                // );
                controls['StartDate'].setValue(fyStartDate);
                controls['EndDate'].setValue(fyEndDate);
                this.maxBudgetDate = moment(fyStartDate)
                    .add(1, 'year')
                    .toDate();
                this.log.verbose({
                    type: 'ProjectBudgetContractComponent:FY',
                    fyStartDate,
                    fyEndDate
                });
            });

        const controls = this.budgetForm.controls;
        controls['StartDate'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(startDate => {
                this.maxBudgetDate = moment(startDate)
                    .add(1, 'years')
                    .add(-1, 'days')
                    .toDate();
            });
        combineLatest([
            controls['StartDate'].valueChanges.pipe(
                startWith(controls['StartDate'].value)
            ),
            controls['EndDate'].valueChanges.pipe(
                startWith(controls['EndDate'].value)
            )
        ])
            .pipe(takeWhile(() => this.active))
            .subscribe(([startDate, endDate]) => {
                this.FiscalYearChange.next([startDate, endDate]);
            });
    }
    onRowEditInit(item: fromDataServices.ProjectBudget.ProjectBudget) {
        this.cloned[item.id] = clone(item);
        this.editing = clone(item);
        this.log.verbose({
            type: 'ProjectBudgetComponent:onRowEditInit',
            item,
            cloned: this.cloned,
            editing: this.editing
        });
        this.Select.next(item);
        this.Edit.next(item);
        this.selected = [];
    }
    onRowEditSave(item: fromDataServices.ProjectBudget.ProjectBudget) {
        const i = clone(item) as fromDataServices.ProjectBudget.ProjectBudget;
        const cols = getDynamicColumns(item, this.filterItems);
        let updated = cols.length;
        cols.forEach(c => {
            const keys = Object.keys(i[c]);
            if (!keys.some(k => i[c][k] !== this.editing[c][k])) {
                delete i[c];
                updated--;
            } else {
                i[c].AutoCalculateAmount =
                    this.budgetForm.controls['AutoCalculateAmount'].value;
            }
        });
        this.log.verbose({
            type: 'ProjectBudgetComponent:onRowEditSave',
            cols,
            item,
            i,
            cloned: this.cloned,
            selected: this.selected,
            editing: this.editing,
            updated
        });
        if (
            i.PersonListID != this.editing?.PersonListID ||
            i.SIListID != this.editing?.SIListID ||
            i.PIListID != this.editing?.PIListID
        ) {
            //if nothing in the budget details has changed, need to add the first one for a txn id to identify
            //this as an update and not a new budget
            if (updated <= 0) {
                i[cols[0]] = item[cols[0]];
            }
            this.SaveMetadata.next(i);
        }

        if (updated > 0) {
            i.Status = {
                StatusCode: ResponseStatus.Loading,
                Message: 'Saving'
            };
            item.Status = {
                StatusCode: ResponseStatus.Loading,
                Message: 'Saving'
            };
            i.AutoCalculateAmount =
                this.budgetForm.controls['AutoCalculateAmount'].value;
            this.Save.next(i);
        }
        delete this.cloned[item.id];
        delete this.editing;
        this.selected = [];
        this.Cancel.next(i);
    }
    onRowEditCancel(item: fromDataServices.ProjectBudget.ProjectBudget) {
        this.log.verbose({
            type: 'ProjectBudgetComponent:onRowEditCancel',
            item,
            cloned: this.cloned,
            editing: this.editing
        });
        let index = this.items.findIndex(x => x.id === item.id);

        if (index >= 0) {
            if (this.editing) {
                this.items.splice(index, 1, this.editing);
            }
        }
        index = this.items.findIndex(x => x.id === 'add');
        if (index >= 0) {
            this.items.splice(index, 1);
        }
        this.items = [...this.items];
        this.selected = [];

        delete this.cloned[item.id];
        delete this.editing;
        this.dataTable.reset();
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
        this.Cancel.next(item);
    }
    onRowSelect($event) {
        this.log.verbose({
            type: 'ProjectBudgetComponent:onRowSelect',
            $event
        });
        this.Select.next($event.data);
    }
    onRowUnselect($event) {
        // Only clear selection if we're down to zero selections
        // This allows multiselect for delete operations
        if (this.dataTable && (!this.dataTable.selection || this.dataTable.selection.length === 0)) {
            this.dataTable.selection = null;
        }
    }
    onRowEditDelete(items: fromDataServices.ProjectBudget.ProjectBudget[]) {
        const cols = getDynamicColumns(items[0], this.filterItems);
        this.log.verbose({
            type: 'ProjectBudgetComponent:onRowEditDelete',
            cols,
            items
        });
        this.confirmservice
            .confirm({
                dialogText:
                    items.length === 1
                        ? 'Are you sure you want to delete this project budget?'
                        : 'Are you sure you want to delete these project budgets?',
                okClass: 'p-button-danger p-button-text'
            })
            .pipe(take(1))
            .subscribe(confirmed => {
                if (confirmed) {
                    this.selected = [];
                    items.forEach(item => this.Delete.next(item));
                }
                this.dataTable.selection = null;
            });
    }
    onJumpstart() {
        this.confirmservice
            .confirm({
                dialogText:
                    'Jumpstart removes existing budgets for the selected contract and fiscal year',
                okClass: 'p-button-danger p-button-text'
            })
            .pipe(take(1))
            .subscribe(confirmed => {
                if (confirmed) {
                    this.Jumpstart.next();
                }
            });
    }
    disburse(item: fromDataServices.ProjectBudget.ProjectBudget) {
        this.log.verbose({
            type: 'ProjectBudgetComponent:disburse',
            item
        });
        this.service.applyDisbursement(item);
    }
    showAmountsChanged() {
        if (this.items && this.items.length) {
            this.mapColumns(this.items[0]);
        }
    }
    showActualsChanged() {
        if (this.items && this.items.length) {
            this.loading = true;
            this.cdRef.detectChanges();
            this.mapColumns(this.items[0]);
            this.loading = false;
            this.cdRef.detectChanges();
        }
    }
    /**
     * we want the highest number that stays below what they entered
     */
    getDisbursementAmount(value: number): number {
        return this.service.getDisbursementAmount(value);
    }
    formatBudgetColumn = (item: ProjectBudget, col: IColumn) => {
        try {
            if (item && item[col.group]) {
                if (col.field === 'TxnID') {
                    return '';
                }
                if (col.field.includes('Amount')) {
                    return new CurrencyPipe(this.locale).transform(
                        item[col.group][col.field]
                    );
                }
                return item[col.group][col.field];
            }
            return '';
        } catch (e) {
            this.log.error(e, item, col);
        }
    };
    showEmptyBudgetsChange() {
        this.log.verbose({
            type: 'ProjectBudgetComponent:showEmptyBudgetsChange',
            showEmptyBudgets: this.showEmptyBudgets
        });
        const dynCols = getDynamicColumns(this.items[0], this.filterItems);
        this.filteredItems = this.items
            .filter(x => x.id !== 'jumpstart')
            .filter(
                x =>
                    this.cols
                        .filter(
                            c => c.field === 'Hours' || c.field === 'Amount'
                        )
                        .reduce((a, c) => {
                            return (
                                this.showEmptyBudgets || a + x[c.group][c.field]
                            );
                        }, 0) > 0
            )
            .map(x => ({
                ...x,
                YearlyBudgetAmount: dynCols.reduce(
                    (a, c) => a + Number(x[c].Amount),
                    0
                ),
                YearlyBudgetHours: dynCols.reduce(
                    (a, c) => a + Number(x[c].Hours),
                    0
                )
            }));

        // Set column frozen after filtered items are updated
        this.cdRef.detectChanges();
        this.setColumnFrozenWhenReady();
    }
    onExport($event: { data: any; field: string }) {
        return $event.data;
    }
    onGetField(field, group) {
        return data => {
            return data[group][field];
        };
    }
    onAutoCalcChange($event) {
        this.log.verbose({
            type: 'ProjectBudgetComponent:onAutoCalcChange',
            $event
        });
    }
    isAdmin = (roles: IUserRole[]): boolean =>
        roles &&
        !!roles.find(x => x.RoleGroupID === UserRoleEnum.Administrator);
    isTaskManager = (roles: IUserRole[]): boolean =>
        roles && !!roles.find(x => x.RoleGroupID === UserRoleEnum.TaskManager);
    trackBy = (index, item) => item.id;

    private setColumnFrozenWhenReady(): void {
        if (
            this.filteredItems &&
            this.filteredItems.length > 0 &&
            this.cols &&
            this.cols.length > 0
        ) {
            setTimeout(() => {
                this.IsColumnFrozen = true;
                this.cdRef.detectChanges();
            }, 0);
        }
    }

    private setColumnFrozenWhenTableReady(): void {
        if (
            this.dataTable &&
            this.dataTable.el &&
            this.dataTable.el.nativeElement
        ) {
            const tableElement =
                this.dataTable.el.nativeElement.querySelector('table');
            if (tableElement) {
                this.IsColumnFrozen = true;
                this.cdRef.detectChanges();
            } else {
                setTimeout(() => this.setColumnFrozenWhenTableReady(), 50);
            }
        } else {
            setTimeout(() => this.setColumnFrozenWhenTableReady(), 50);
        }
    }

    onUpdateBudgetDialogOpen(): void {
        if (this.dataTable.selection && this.dataTable.selection.length === 1) {
            this.selectedBudgetForUpdate = this.dataTable.selection[0];
            this.populateUpdateBudgetForm(this.selectedBudgetForUpdate);
        }
    }

    populateUpdateBudgetForm(budget: ProjectBudget): void {
        if (!this.tasks.length && budget.TaskListID) {
            this.tasks = [
                {
                    label: budget.TaskLongName,
                    value: budget.TaskListID
                }
            ];
        } else if (
            budget.TaskListID &&
            !this.tasks.find(t => t.value === budget.TaskListID)
        ) {
            this.tasks.push({
                label: budget.TaskLongName,
                value: budget.TaskListID
            });
        }

        if (!this.costTypes.length && budget.CostType) {
            this.costTypes = [
                {
                    label: budget.CostType,
                    value: budget.CostType
                }
            ];
        } else if (
            budget.CostType &&
            !this.costTypes.find(ct => ct.value === budget.CostType)
        ) {
            this.costTypes.push({
                label: budget.CostType,
                value: budget.CostType
            });
        }

        if (
            this.CostCenters &&
            this.CostCenters.length > 0 &&
            this.costCenters.length === 0
        ) {
            this.costCenters = this.CostCenters.map(cc => ({
                label: cc.GroupName,
                value: cc.GroupID
            }));
        }

        this.updateBudgetForm.patchValue({
            TaskListID: budget.TaskListID,
            CostType: budget.CostType,
            SIListID: budget.SIListID,
            PersonListID: budget.PersonListID,
            PIListID: budget.PIListID,
            CostCenterID: budget.CostCenterID,
            Periods: [],
            Hours: null,
            Amount: null,
            Disburse: false
        });
    }

    onUpdateBudgetSave(): void {
        if (this.updateBudgetForm.valid && this.selectedBudgetForUpdate) {
            const formValue = this.updateBudgetForm.value;
            const periods = formValue.Periods || [];
            let hours = Number(formValue.Hours) || 0;
            let amount = Number(formValue.Amount) || 0;
            if (formValue.Disburse && periods.length) {
                hours = this.service.getDisbursementAmount(
                    hours / periods.length
                );
                amount = this.service.getDisbursementAmount(
                    amount / periods.length
                );
            }
            const updateData = {
                ...this.selectedBudgetForUpdate,
                Periods: periods,
                Hours: hours,
                Amount: amount
            };

            this.UpdateBudget.next(updateData);
            this.showUpdateBudgetDialog = false;
            this.updateBudgetForm.reset();
            this.selectedBudgetForUpdate = null;
            if (this.dataTable) {
                this.dataTable.selection = null;
            }
        }
    }

    onUpdateBudgetCancel(): void {
        this.showUpdateBudgetDialog = false;
        this.updateBudgetForm.reset();
        this.selectedBudgetForUpdate = null;
    }
}
